import { goSolidApi } from "@/composables/useGoSolidApi";
import type {
  ChatConversationPage,
  ChatMessageDetail,
  ChatMessagePage,
  ChatMessageQuery,
} from "./tradeChatLogsTypes";

const ROOT = "/api/admin/trade-audit-log";

/** Searches captured chat messages, one keyset page at a time. Errors propagate to the caller. */
export async function searchMessages(
  query: ChatMessageQuery,
  signal?: AbortSignal
): Promise<ChatMessagePage> {
  return (await goSolidApi.get(`${ROOT}/messages`, { params: query, signal }))
    .data;
}

/** Lists conversations, most recently active first. */
export async function listConversations(
  params: { q?: string; limit?: number },
  signal?: AbortSignal
): Promise<ChatConversationPage> {
  return (await goSolidApi.get(`${ROOT}/conversations`, { params, signal }))
    .data;
}

/** Loads one message with its payload, extracted trade signals and surrounding conversation. */
export async function getMessage(
  id: number,
  context: number,
  signal?: AbortSignal
): Promise<ChatMessageDetail> {
  return (
    await goSolidApi.get(`${ROOT}/messages/${id}`, {
      params: { context },
      signal,
    })
  ).data;
}
